const SIGN_UP = '/signup';
const SIGN_IN = '/signin';
const LANDING = '/';
const HOME = '/home';
const ACCOUNT = '/account';
const ADMIN = '/admin';
const PASSWORD_FORGET = '/pw-forget';

export const ROUTES = { SIGN_IN, SIGN_UP, LANDING, HOME, ACCOUNT, ADMIN, PASSWORD_FORGET }